module.exports = __webpack_public_path__ + "static/media/Galileo_background_music.1562d70f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_background_music.wav
// module id = 187
// module chunks = 0